import { useMutation } from '@tanstack/react-query'

import { authApi } from '../api/authApi'

export const usePresubscriberMutation = () => {
  return useMutation({
    mutationFn: (payload: Parameters<typeof authApi.postPresubscriber>[0]) => authApi.postPresubscriber(payload),
  })
}
